module.exports = __webpack_public_path__ + "static/media/POOL-301-badge.322e754b.svg";